import { View } from '@react-pdf/renderer';
import { PDFCheckbox, PDFParagraphBlock } from './index';
import PdfParagraphBlock from './ParagraphBlock';
import i18next from 'i18next';
import { I18nNameSpaces } from '../../services/i18n';
import { CheckboxTreeOption } from '../../fields/CheckboxTree';
import { InvestingGoalsFormValues } from '../../models/Forms';

interface Props {
  treeTemplate: CheckboxTreeOption[];
  answers: InvestingGoalsFormValues['g'];
}

export default function PDFCheckboxTree({ treeTemplate, answers }: Props) {
  const t = i18next.getFixedT(null, I18nNameSpaces.Forms);

  return (
    <View>
      {treeTemplate.map((d) => (
        <View key={d.value}>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ width: '36%', paddingRight: '3%' }}>
              <PDFCheckbox checked={(answers as Record<string, any>)[d.value]?.checked ?? false} label={t(d.label)} />
            </View>
            {d.inputs ? (
              <View
                style={{
                  width: '50%',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                {d.inputs.map((input) => (
                  <View key={input.name}>
                    <PDFParagraphBlock style={{ paddingRight: '8px' }}>
                      <PDFParagraphBlock>{`${t(input.label)} `}</PDFParagraphBlock>
                      <PdfParagraphBlock bold>
                        {(answers as Record<string, any>)[d.value]?.[input.name] ?? ''}
                      </PdfParagraphBlock>
                    </PDFParagraphBlock>
                  </View>
                ))}
              </View>
            ) : null}
          </View>
          {d.children ? (
            <View style={{ marginLeft: '10px' }}>
              <PDFCheckboxTree treeTemplate={d.children} answers={(answers as Record<string, any>)[d.value] || {}} />
            </View>
          ) : null}
        </View>
      ))}
    </View>
  );
}
